module.exports = "/_next/static/images/Retail-Header-Image-cd0652d84ba0381ff8e9998353ebe117.jpg";